import React from 'react';
import GuidePopover from '../guidePopover';
import { useActions, HollowOutGuideAction } from '@web-common/state/createStore';
import styles from './tipGuide.module.scss';
const TipGuide = props => {
    const { placement = 'bottomLeft', show, guideId, onStep, title, children, onClose } = props;
    const { doNextStep } = useActions(HollowOutGuideAction);
    const handleNext = () => {
        doNextStep({ step: onStep, guideId });
        onClose && onClose();
    };
    const ContentTitle = () => {
        return (React.createElement("p", { className: styles.contentBox },
            React.createElement("span", { className: styles.contentTitle }, title),
            React.createElement("span", { className: styles.contentCloakingBtn }),
            React.createElement("span", { className: styles.contentBtn, onClick: handleNext }, "\u77E5\u9053\u4E86")));
    };
    return (React.createElement(GuidePopover, { type: "3", content: React.createElement(ContentTitle, null), visible: !!show, placement: placement }, children));
};
export default TipGuide;
